import { createTheme, responsiveFontSizes, SimplePaletteColorOptions } from '@mui/material/styles'

import { ThemeOptions } from '@mui/material/styles'

declare module '@mui/material/Chip' {
	interface ChipPropsVariantOverrides {
		Layer1WorkItem: true
		Layer2WorkItem: true
		Layer3WorkItem: true
		Layer4WorkItem: true
		Layer5WorkItem: true
		Layer1OutOfScope: true
		Layer2OutOfScope: true
		Layer3OutOfScope: true
		Layer4OutOfScope: true
		Layer5OutOfScope: true
		backlogWorkItem: true
		task: true
		worker: true
		workitem: true
		'rework chip': true
		Archived: true
		Active: true
		Inactive: true
		Draft: true
		workers: true
		workitems: true
		specifications: true
		activity: true
		active: true
		failure: true
		success: true
		MaterialManager: true
		Material: true
		OfficeAdmin: true
		LineTech: true
		Tracker: true
		LineTechManager: true
		QualityControl: true
		QualityControlManager: true
		Laborer: true
		Foreman: true
		GeneralForeman: true
		Superintendent: true
		ProjectControls: true
		SuperAdmin: true
		Succeeded: true
		Failed: true
		Rework: true
		Processing: true
		Partial: true
		'Not Started': true
		Constrained: true
		Pending: true
		'Pending Final': true
		Passed: true
		'Failed ITP': true
		Complete: true
		Online: true
		Offline: true
		'Pending Witness': true
		'Pending Inspection': true
		'Passed Inspection': true
		'Failed Inspection': true
		'Work Stopped': true
		Removed: true
		time: true
		Ready: true
		Rejected: true
		Unassigned: true
		Kitted: true
		Surveyed: true
		'Pending Material': true
		'Pending Survey': true
	}
}

const colorThemeOptions: ThemeOptions = {
	palette: {
		mode: 'light',
		primary: {
			main: '#141B4D',
			light: '#bbdefb',
		},
		secondary: {
			main: '#0DAEFF',
		},
		info: {
			main: '#46B2ED',
		},
		error: {
			main: '#CC0C00',
		},
		warning: {
			main: '#FCA32C',
		},
		success: {
			main: '#0DB270',
		},
	},
}

const chipThemeOptions: ThemeOptions = {
	components: {
		MuiChip: {
			styleOverrides: {
				// The props to change the default for.
				root: {
					borderRadius: '4px',
					elevation: 0,
					boxShadow: 'none',
					textTransform: 'capitalize',
					padding: 0,
					margin: 0,
					fontSize: '14px',
					fontWeight: '500',
				},
			},
			variants: [
				{
					props: { variant: 'Layer1WorkItem' },
					style: {
						color: '#fff',
						background: '#E74C3C',
					},
				},
				{
					props: { variant: 'Layer2WorkItem' },
					style: {
						color: '#fff',
						background: '#3498DB',
					},
				},
				{
					props: { variant: 'Layer3WorkItem' },
					style: {
						color: '#fff',
						background: '#228B22',
					},
				},
				{
					props: { variant: 'Layer4WorkItem' },
					style: {
						color: '#fff',
						background: '#4B0082',
					},
				},
				{
					props: { variant: 'Layer5WorkItem' },
					style: {
						color: '#fff',
						background: '#008B8B',
					},
				},
				{
					props: { variant: 'Layer1OutOfScope' },
					style: {
						color: '#fff',
						background: '#2ECC71', // Bright Emerald Green
					},
				},
				{
					props: { variant: 'Layer2OutOfScope' },
					style: {
						color: '#fff',
						background: '#8E44AD', // Deep Purple
					},
				},
				{
					props: { variant: 'Layer3OutOfScope' },
					style: {
						color: '#fff',
						background: '#E67E22', // Vibrant Orange
					},
				},
				{
					props: { variant: 'Layer4OutOfScope' },
					style: {
						color: '#fff',
						background: '#E91E63', // Bold Pink
					},
				},
				{
					props: { variant: 'Layer5OutOfScope' },
					style: {
						color: '#fff',
						background: '#F1C40F', // Vibrant Sunflower Yellow
					},
				},

				{
					props: { variant: 'backlogWorkItem' },
					style: {
						color: '#fff',
						background: '#F04438',
					},
				},
				{
					props: { variant: 'task' },
					style: {
						color: '#fff',
						background: '#F59E0B',
					},
				},
				{
					props: { variant: 'rework chip' },
					style: {
						color: '#fff',
						background: '#F43F5E',
					},
				},
				{
					props: { variant: 'worker' },
					style: {
						color: '#fff',
						background: '#4FABF9',
					},
				},
				{
					props: { variant: 'activity' },
					style: {
						color: '#fff',
						background: '#755CF0',
					},
				},
				{
					props: { variant: 'time' },
					style: {
						color: '#fff',
						background: '#F59E0B',
					},
				},
				{
					props: { variant: 'workers' },
					style: {
						background: '#EBE9FE',
						color: '#7A5AF8',
					},
				},
				{
					props: { variant: 'workitems' },
					style: {
						background: '#E0F2FE',
						color: '#0BA5EC',
					},
				},
				{
					props: { variant: 'specifications' },
					style: {
						background: '#DFF6DD',
						color: '#4CAF50',
					},
				},
				{
					props: { variant: 'Active' },
					style: {
						background: '#D1FADF',
						color: (colorThemeOptions.palette?.success as SimplePaletteColorOptions).main,
						padding: 0,
					},
				},
				{
					props: { variant: 'Inactive' },
					style: {
						background: '#FEDDDD',
						color: '#EF4444',
						padding: 0,
					},
				},
				{
					props: { variant: 'Archived' },
					style: {
						background: '#FEDDDD',
						color: '#EF4444',
						padding: 0,
					},
				},
				{
					props: { variant: 'Draft' },
					style: {
						background: (colorThemeOptions.palette?.info as SimplePaletteColorOptions).main,
						color: '#fff',
						padding: 0,
					},
				},
				{
					props: { variant: 'failure' },
					style: {
						background: '#FEDDDD',
						color: '#EF4444',
					},
				},
				{
					props: { variant: 'success' },
					style: {
						background: '#D1FADF',
						color: (colorThemeOptions.palette?.success as SimplePaletteColorOptions).main,
						padding: 0,
					},
				},
				{
					props: { variant: 'LineTech' },
					style: {
						backgroundColor: '#4169E1',
					},
				},
				{
					props: { variant: 'QualityControl' },
					style: {
						backgroundColor: '#D9BA21',
					},
				},
				{
					props: { variant: 'QualityControlManager' },
					style: {
						backgroundColor: '#B89E1C',
					},
				},
				{
					props: { variant: 'LineTechManager' },
					style: {
						backgroundColor: '#27408B',
					},
				},
				{
					props: { variant: 'Laborer' },
					style: {
						backgroundColor: '#12B76A',
					},
				},
				{
					props: { variant: 'Foreman' },
					style: {
						backgroundColor: '#F59E0B',
					},
				},
				{
					props: { variant: 'GeneralForeman' },
					style: {
						backgroundColor: '#F04438',
					},
				},
				{
					props: { variant: 'Superintendent' },
					style: {
						backgroundColor: '#0DAEFF',
					},
				},
				{
					props: { variant: 'ProjectControls' },
					style: {
						backgroundColor: '#7A5AF8',
					},
				},
				{
					props: { variant: 'SuperAdmin' },
					style: {
						backgroundColor: '#0DAEFF',
					},
				},
				{
					props: { variant: 'Succeeded' },
					style: {
						backgroundColor: '#12B76A',
					},
				},
				{
					props: { variant: 'Failed' },
					style: {
						backgroundColor: '#EF4444',
					},
				},
				{
					props: { variant: 'Processing' },
					style: {
						backgroundColor: '#0DAEFF',
					},
				},
				{
					props: { variant: 'Partial' },
					style: {
						backgroundColor: '#D9BA21',
					},
				},
				{
					props: { variant: 'Not Started' },
					style: {},
				},
				{
					props: { variant: 'Constrained' },
					style: {},
				},
				{
					props: { variant: 'Pending' },
					style: {
						background: '#FEF3C7', // Light yellow background
						color: '#D97706', // Amber text
					},
				},
				{
					props: { variant: 'Pending Final' },
					style: {},
				},
				{
					props: { variant: 'Passed' },
					style: {
						background: '#D1FAE5', // Light green background
						color: '#059669', // Green text
					},
				},
				{
					props: { variant: 'Failed ITP' },
					style: {},
				},
				{
					props: { variant: 'Rework' },
					style: { background: '#FEDDDD', color: '#EF4444' },
				},
				{
					props: { variant: 'Complete' },
					style: {},
				},
				{
					props: { variant: 'Offline' },
					style: {
						backgroundColor: '#FEDDDD',
						color: '#EF4444',
					},
				},
				{
					props: { variant: 'Online' },
					style: {
						backgroundColor: '#D1FADF',
						color: '#12B76A',
					},
				},
				{
					props: { variant: 'Ready' },
					style: {
						background: '#E0F2FE', // Light blue background
						color: '#0284C7', // Blue text
					},
				},
				{
					props: { variant: 'Rejected' },
					style: {
						background: '#FEE2E2', // Light red background
						color: '#DC2626', // Red text
					},
				},
				{
					props: { variant: 'MaterialManager' },
					style: {
						backgroundColor: '#2E7D32', // Darker green
					},
				},
				{
					props: { variant: 'Material' },
					style: {
						backgroundColor: '#43A047', // Lighter green
					},
				},
				{
					props: { variant: 'OfficeAdmin' },
					style: {
						backgroundColor: '#546E7A',
					},
				},
				{
					props: { variant: 'Surveyed' },
					style: {
						background: '#E8F5E8',
						color: '#2E7D32',
					},
				},
				{
					props: { variant: 'Pending Material' },
					style: {
						background: '#FFF3E0',
						color: '#E65100',
					},
				},
				{
					props: { variant: 'Pending Survey' },
					style: {
						background: '#F3E5F5',
						color: '#7B1FA2',
					},
				},
			],
		},
	},
}
const componentThemeOptions: ThemeOptions = {
	components: {
		// Name of the components
		MuiButton: {
			styleOverrides: {
				// The props to change the default for.
				root: {
					borderRadius: '4px',
					elevation: 0,
					boxShadow: 'none',
					textTransform: 'capitalize',
					color: 'white',
				},
			},
		},
		MuiList: {
			styleOverrides: {
				root: {
					paddingTop: 0,
					paddingBottom: 0,
				},
			},
		},
		MuiListItem: {
			styleOverrides: {
				root: {
					'&:hover': {
						backgroundColor: (colorThemeOptions.palette?.primary as SimplePaletteColorOptions).main,
						color: 'white',
						'& .MuiListItemIcon-root': {
							color: 'white',
						},
					},
					width: '245px',
					padding: 0,
				},
			},
		},
		MuiListItemIcon: {
			styleOverrides: {
				root: {
					minWidth: 'inherit',
					width: '36px',
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					textTransform: 'capitalize',
					marginLeft: '30px',
					marginRight: '-20px',
				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				root: {
					whiteSpace: 'nowrap',
				},
			},
		},
	},
}

const componentThemeOptions2: ThemeOptions = {
	components: {
		MuiListItem: {
			styleOverrides: {
				root: {
					'&:hover': {
						backgroundColor: 'none',
						color: 'inherit',
						'& .MuiListItemIcon-root': {
							color: 'inherit',
						},
					},
				},
			},
		},
		MuiListItemIcon: {
			styleOverrides: {
				root: {
					minWidth: 'inherit',
					width: '36px',
				},
			},
		},
	},
}

const sideNavBarThemeOptions: ThemeOptions = {
	components: {
		MuiList: {
			styleOverrides: {
				root: {
					marginTop: '15px',
					paddingTop: 0,
					paddingBottom: 0,
					margin: '15px 5px',
				},
			},
		},
		MuiListItemButton: {
			styleOverrides: {
				root: {
					'&:hover': {
						color: '#262626',
						background: 'none',
						'& .MuiListItemIcon-root': {
							color: '#262626',
						},
					},
				},
			},
		},
		MuiListItem: {
			styleOverrides: {
				root: {
					'&:hover': {
						color: '#262626',
						background: '#dddddd',
						'& .MuiListItemIcon-root': {
							color: '#262626',
						},
					},
					padding: '0px 10px',
					margin: 0,
					gap: '5px',
					fontWeight: 500,
					borderRadius: '8px',
					width: '239px',
					color: '#262626',
				},
			},
		},
		MuiListItemIcon: {
			styleOverrides: {
				root: {
					minWidth: 'inherit',
					width: '36px',
					color: '#262626',
				},
			},
		},
	},
}
const getSideNavBarTheme = () => {
	const fullTheme = createTheme(colorThemeOptions, chipThemeOptions, sideNavBarThemeOptions)
	return responsiveFontSizes(fullTheme)
}

const getDefaultTheme = () => {
	const fullTheme = createTheme(componentThemeOptions, colorThemeOptions, chipThemeOptions)
	return responsiveFontSizes(fullTheme)
}

const getHoverlessListTheme = () => {
	const fullTheme = createTheme(componentThemeOptions2, colorThemeOptions, chipThemeOptions)
	return responsiveFontSizes(fullTheme)
}

export { getDefaultTheme, getHoverlessListTheme, getSideNavBarTheme }
